import api from '../';

const set = token => {
  if (token) {
    try {
      api.defaults.headers.common['x-auth-token'] = token;
    } catch (error) { }

    localStorage.setItem('token', token);
  } else {
    try {
      delete api.defaults.headers.common['x-auth-token'];
    } catch (error) { }
    if (localStorage.token) localStorage.removeItem('token');
  }
};

export default set;